<div class="container-fluid">
	<div *ngIf="listError" class="alert alert-danger py-2">{{ listError }}</div>

	<div class="row">
		<!-- Template list -->
		<div class="col-md-3 template-list">
			<div class="list-group">
				<button *ngFor="let t of templates"
					type="button"
					class="list-group-item list-group-item-action"
					[class.active]="t.name === selectedName"
					(click)="selectTemplate(t.name)">
					<div class="font-weight-bold">{{ t.name }}</div>
					<small [class.text-muted]="t.name !== selectedName">{{ t.description }}</small>
					<small class="d-block">v{{ t.currentVersion }}</small>
				</button>
			</div>
		</div>

		<!-- Editor + preview -->
		<div class="col-md-9">
			<p *ngIf="!selectedName" class="text-muted py-3">Select a template to edit.</p>

			<ng-container *ngIf="selectedName">
				<div *ngIf="editorError" class="alert alert-danger py-2">{{ editorError }}</div>

				<ul class="nav nav-tabs mb-3">
					<li class="nav-item">
						<a class="nav-link" [class.active]="activeTab === 'edit'" (click)="activeTab = 'edit'" href="javascript:void(0)">Edit</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" [class.active]="activeTab === 'history'" (click)="openHistory()" href="javascript:void(0)">History</a>
					</li>
				</ul>

				<!-- ─── Edit tab ─── -->
				<div *ngIf="activeTab === 'edit'">
					<div *ngIf="conflictTemplate" class="alert alert-warning">
						Another admin saved version {{ conflictTemplate.currentVersion }} while you were editing.
						<button class="btn btn-sm btn-warning ml-2" (click)="reloadConflict()">Reload latest</button>
					</div>
					<div *ngIf="restoredFromVersion" class="alert alert-info py-2">
						Loaded version {{ restoredFromVersion }} into the editor. Review and Save to create a new version.
					</div>
					<div *ngIf="saveMessage" class="alert alert-success py-2">{{ saveMessage }}</div>

					<div class="row">
						<!-- Left: editor -->
						<div class="col-lg-7">
							<div class="form-group">
								<label for="tpl-subject">Subject</label>
								<input id="tpl-subject" type="text" class="form-control" spellcheck="false"
									[(ngModel)]="subject" (ngModelChange)="updatePreview()">
							</div>

							<div class="form-group">
								<label for="tpl-body">Body (HTML)</label>
								<textarea id="tpl-body" class="form-control body-editor" rows="14" spellcheck="false"
									[(ngModel)]="bodyHtml" (ngModelChange)="updatePreview()"></textarea>
							</div>

							<div class="form-row">
								<div class="form-group col-md-6">
									<label>Default CC</label>
									<div class="chip-row">
										<span *ngFor="let cc of ccList" class="badge badge-pill badge-secondary chip">
											{{ cc }} <button type="button" class="chip-remove" (click)="removeCc(cc)">&times;</button>
										</span>
									</div>
									<div class="input-group input-group-sm">
										<input type="text" class="form-control" placeholder="add email…" [(ngModel)]="ccInput" (keyup.enter)="addCc()">
										<div class="input-group-append">
											<button class="btn btn-outline-secondary" type="button" (click)="addCc()">Add</button>
										</div>
									</div>
								</div>
								<div class="form-group col-md-6">
									<label>Default BCC</label>
									<div class="chip-row">
										<span *ngFor="let bcc of bccList" class="badge badge-pill badge-secondary chip">
											{{ bcc }} <button type="button" class="chip-remove" (click)="removeBcc(bcc)">&times;</button>
										</span>
									</div>
									<div class="input-group input-group-sm">
										<input type="text" class="form-control" placeholder="add email…" [(ngModel)]="bccInput" (keyup.enter)="addBcc()">
										<div class="input-group-append">
											<button class="btn btn-outline-secondary" type="button" (click)="addBcc()">Add</button>
										</div>
									</div>
								</div>
							</div>

							<div class="form-group">
								<label for="tpl-note">Change note (optional)</label>
								<input id="tpl-note" type="text" class="form-control form-control-sm" [(ngModel)]="changeNote"
									placeholder="what changed and why">
							</div>

							<button class="btn btn-primary mb-3" (click)="save()">Save</button>

							<!-- Variables reference -->
							<div class="card">
								<div class="card-header py-2 d-flex justify-content-between align-items-center">
									<span class="font-weight-bold">Variables</span>
									<button class="btn btn-sm btn-link p-0" type="button" (click)="loadLatestSend()">Load last real send example</button>
								</div>
								<div class="card-body py-2">
									<p class="text-muted small mb-2">Reference only — type a variable into the subject or body. Links (marked <span class="badge badge-info">HTML</span>) use triple braces so they render as clickable links. The sample values below feed the preview.</p>
									<div *ngIf="lastSendMessage" class="text-muted small mb-2">{{ lastSendMessage }}</div>
									<div *ngFor="let v of schema" class="variable-row form-row align-items-center">
										<div class="col-md-5">
											<code>{{ variableToken(v) }}</code>
											<span *ngIf="v.html" class="badge badge-info ml-1" title="Raw HTML — renders as a clickable link">HTML</span>
											<div class="text-muted small">{{ v.description }}</div>
										</div>
										<div class="col-md-7">
											<input type="text" class="form-control form-control-sm"
												[(ngModel)]="sampleValues[v.name]" (ngModelChange)="updatePreview()" placeholder="sample value">
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Right: live preview -->
						<div class="col-lg-5">
							<label class="font-weight-bold mb-1">Preview</label>
							<div class="preview-chrome">
								<div class="preview-meta"><span class="preview-label">From</span> Project Board</div>
								<div class="preview-meta"><span class="preview-label">To</span> {{ previewTo }}</div>
								<div *ngIf="ccList.length" class="preview-meta"><span class="preview-label">CC</span> {{ ccList.join(', ') }}</div>
								<div class="preview-meta"><span class="preview-label">Subject</span> {{ renderedSubject }}</div>
							</div>
							<iframe class="preview-body-frame" sandbox="allow-popups allow-popups-to-escape-sandbox" [srcdoc]="renderedBodySafe" title="Template preview"></iframe>
							<div *ngIf="previewMissing.length" class="text-warning small mt-2">
								Unresolved variables: {{ previewMissing.join(', ') }}
							</div>
						</div>
					</div>
				</div>

				<!-- ─── History tab ─── -->
				<div *ngIf="activeTab === 'history'">
					<table class="table table-sm table-hover">
						<thead>
							<tr>
								<th>Version</th>
								<th>Updated</th>
								<th>By</th>
								<th>Change note</th>
								<th class="text-right">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let v of history">
								<td>v{{ v.versionNumber }}</td>
								<td class="text-nowrap">{{ v.updatedAt | date:'short' }}</td>
								<td>{{ v.updatedByUserId ?? '—' }}</td>
								<td>{{ v.changeNote || '—' }}</td>
								<td class="text-right text-nowrap">
									<button class="btn btn-sm btn-link" (click)="viewDiff(v)">View diff</button>
									<button class="btn btn-sm btn-link" (click)="restore(v)">Restore</button>
								</td>
							</tr>
							<tr *ngIf="history.length === 0">
								<td colspan="5" class="text-center text-muted py-3">No version history.</td>
							</tr>
						</tbody>
					</table>
				</div>
			</ng-container>
		</div>
	</div>
</div>
